
export const leadsFields = {
  id: 'id',
  email: 'email',
  phoneNumber: 'phoneNumber',
  name: 'name',
  address: 'address',
  city: 'city',
  state: 'state',
  zipCode: 'zip_code',
  sourceOrg: 'sourceOrg',
  batchId: 'importBatchId',
  status: 'status',
  isArchived: 'isArchived',
  archivedReason: 'archivedReason',
  smsOptIn: 'smsOptIn',
  brazeGroupId: 'brazeGroupId',
  errorFlag: 'errorFlag',
  errorDetails: 'errorDetails',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  enrolledAt: 'enrolledAt',
  signedUpAt: 'signedUpAt',
  reactivatedAt: 'reactivatedAt',
  reactivationCount: 'reactivationCount',
  userId: 'userId',
  insurancePlan: 'insurancePlan',
  employer: 'employer',
  externalId: 'externalId',
  language: 'language',
  birthDate: 'birthDate',
  subscriptionGroupId: 'subscriptionGroupId',
  emailSubscriptionGroupId: 'emailSubscriptionGroupId',
  smsSubscriptionGroupId: 'smsSubscriptionGroupId',
  emailOptIn: 'emailOptIn', // Derived from emailSubscriptionGroupId existence
  wicClinicCode: 'wicClinicCode',
};

export const LeadStatusChoices = [
  { id: 'active', name: 'Active' },
  { id: 'signed_up', name: 'Signed Up' },
  { id: 'enrolled', name: 'Enrolled' },
  { id: 'reactivated', name: 'Reactivated' },
];

export default leadsFields;
